import { useContext } from "react";
import { PrintContext } from "./PrintContext";

/**
 * Hook which indicates whether the component is being rendered
 * in Print mode.
 */
export const usePrinting = () => useContext(PrintContext).isPrinting;
